

































import { Vue, Component, Prop } from "@/shared/vuepack";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import Metric from "@/employer/components/metric/Metric.vue";
import type { ProductPlanTab } from "@/employer/types";
import { Config } from "@/shared/config";

@Component({
  components: {
    CommonTabs,
    CommonTab,
    Metric,
  },
})
export default class MetricTabs extends Vue {
  @Prop() componentTitle!: string;
  @Prop() metricHeight!: string;
  @Prop() metricWidth!: string;
  @Prop() metricTabs!: ProductPlanTab[];
  @Prop() employerCode!: string;
  @Prop() accessToken!: string;

  tableauUrl = Config.UserServicebaseUri;
}
